module.exports = __webpack_public_path__ + "svgs/coupon-3.95045978.svg";